module.exports = __webpack_public_path__ + "img/ps-12.63435970.jpg";